module.exports = __webpack_public_path__ + "static/media/other-income.951a1c75.svg";